
import generateFilterForQuery from './common/_tools';

export class DealExportNoname1Query {

  static build(query: any) {
    return {
      template: DealExportNoname1Query.TEMPLATE,
      queries: {
        deals: DealExportNoname1Query.buildDealsQuery(query)
      },
      format: 'xlsx'
    }
  }

  static TEMPLATE = '<!DOCTYPE html>\n<table font=Verdana font-size=8>\n  <tr>\n    <td wrap bgcolor=FF72BF44 width=10>НомерЗаказа</td>\n    <td wrap bgcolor=FF72BF44 width=10>КодКлиента</td>\n    <td wrap bgcolor=FF72BF44 width=8>КодАдреса</td>\n    <td wrap bgcolor=FF72BF44 width=15>ШтрихКод</td>\n    <td wrap bgcolor=FF72BF44 width=8>Количество</td>\n    <td wrap bgcolor=FF72BF44 width=10>ДатаДоставки</td>\n    <td wrap bgcolor=FF72BF44 width=12>КодОрганизации</td>\n    <td wrap bgcolor=FF72BF44 width=8>ЦенаЗаЕд</td>\n    <td wrap bgcolor=FF72BF44 width=12>АртикулТовара</td>\n    <td width=50></td>\n  </tr>\n\n  {{#deals.documents}}\n    <tr>\n      <td wrap>{{notes}}</td>\n      <td wrap>{{client_code}}</td>\n      <td wrap type=number align=center>{{address_code}}</td>\n      <td wrap align=center>{{barcode}}</td>\n      <td wrap type=number align=center>{{quantity}}</td>\n      <td wrap date-format=YYYYMMDD>{{expected_delivery_date}}</td>\n      <td wrap type=number align=center>28117</td>\n      <td wrap type=number align=center>{{container_price}}</td>\n      <td wrap align=center>{{sku}}</td>\n      <td wrap>{{client_name}} {{#address}}({{address}}){{/address}}</td>\n    </tr>\n  {{/deals.documents}}\n</table>\n';

  static buildDealsQuery(query: any) {
    const filter = generateFilterForQuery(query);
    filter.push({
      '$not': [{
        '$eq': ["deal.status_id", {"$":"d:statuses:19"}]
      }]
    })
    filter.push({
      "$or": [
          {"$null": ["deal.return_type_id"]},
          {"$in": ["deal.return_type_id", {"$": ['d:deals_return_types:2']}]}
      ]
    })

    return {
      columns: {
        client_code: 'client.code',
        address_code: 'delivery_point.address_code',
        barcode: 'product_container.barcode',
        quantity: 'deal_product_container.container_quantity',
        notes: 'deal_product_container.notes',
        expected_delivery_date: 'deal.expected_delivery_date',
        container_price: {
          $div: ['deal_product_container.container_price', 'deal_product_container.container_quantity']
        },
        sku: 'product_container.sku',
        client_name: 'client.name',
        address: 'delivery_point.address',
        point_address: 'delivery_point.address'
      },
      from: 's:deals',
      from_as: 'deal',
      joins: [
        {
          join: 's:clients',
          type: 'left',
          as: 'client',
          on: {
            $eq: [
              'client.id',
              'deal.client_id'
            ]
          }
        },
        {
          join: 's:delivery_points',
          type: 'left',
          as: 'delivery_point',
          on: {
            $eq: [
              'deal.delivery_point_id',
              'delivery_point.id'
            ]
          }
        },
        {
          join: 's:cities',
          type: 'left',
          as: 'city',
          on: {
            $eq: [
              'delivery_point.city_id',
              'city.id'
            ]
          }
        },
        {
          join: 's:deal_product_containers',
          type: 'left',
          as: 'deal_product_container',
          on: {
            $eq: [
              'deal_product_container.deal_id',
              'deal.id'
            ]
          }
        },
        {
          join: 's:product_containers',
          type: 'left',
          as: 'product_container',
          on: {
            $eq: [
              'product_container.id',
              'deal_product_container.product_container_id'
            ]
          }
        }
      ],
      order: [
        {
          $desc: [
            'client.id'
          ]
        },
        {
          $desc: [
            'delivery_point.address'
          ]
        },
        {
          $desc: [
            'product_container.id'
          ]
        }
      ],
      ...(
        filter.length > 1 ?
        {
            "where": {
                "$and": filter
            }
        } : {
            "where": filter[0]
        }
      ),
    }

  }
}